"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dialogBodyClassNames: ()=>dialogBodyClassNames,
    useDialogBodyStyles_unstable: ()=>useDialogBodyStyles_unstable
});
const _react = require("@griffel/react");
const dialogBodyClassNames = {
    root: 'fui-DialogBody'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react["__styles"])({
    root: {
        mc9l5x: "f13qh94s",
        fshzfu: "f120kxnn",
        Bxyxcbc: "flnwrvu",
        B7ck84d: "f1ewtqcl",
        wkccdc: "f874eam",
        Budl1dq: "fjj47a5",
        zoa1oz: "fe34spp",
        B68tc82: "f1ln0qer",
        Bmxbyg5: "fa2wlxz",
        i8kkvl: "f4px1ci",
        Belr9w4: "fn67r4l",
        B5xtmjs: "ff54dml",
        Bqu9lor: "f52bj20",
        B06wobe: "f1dangjo"
    }
}, {
    d: [
        ".f13qh94s{display:grid;}",
        ".f120kxnn::backdrop{background-color:rgba(0, 0, 0, 0.4);}",
        ".flnwrvu{max-height:calc(100vh - 2 * 24px);}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f874eam{grid-template-rows:auto 1fr auto;}",
        ".fjj47a5{grid-template-columns:1fr 1fr auto;}",
        ".fe34spp{grid-template-areas:\"title title close-button\" \"body body body\" \"actions-start actions-end actions-end\";}",
        ".f1ln0qer{overflow-x:unset;}",
        ".fa2wlxz{overflow-y:unset;}",
        ".f4px1ci{-webkit-column-gap:8px;column-gap:8px;}",
        ".fn67r4l{row-gap:8px;}"
    ],
    m: [
        [
            "@media screen and (max-width: 480px){.ff54dml{max-width:100vw;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ],
        [
            "@media screen and (max-width: 480px){.f52bj20{grid-template-rows:auto 1fr auto auto;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ],
        [
            "@media screen and (max-width: 480px){.f1dangjo{grid-template-areas:\"title title close-button\" \"body body body\" \"actions-start actions-start actions-start\" \"actions-end actions-end actions-end\";}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ]
    ]
});
const useDialogBodyStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(dialogBodyClassNames.root, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useDialogBodyStyles.js.map

//# sourceMappingURL=useDialogBodyStyles.js.map